var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"bem-ssr",rawName:"v-bem-ssr",value:(true),expression:"true"}],staticClass:"com-post-title"},[_vm._l((_vm.currentFlagList),function(flagIndex,index){return [_c('span',{key:index,class:['com-post-title-label', ("title-flag-" + flagIndex)]})]}),_c('span',{staticClass:"com-post-title-content"},[_vm._v(_vm._s(_vm.title))])],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-770a0f0b","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/component/post-title/index.vue
// module id = 534
// module chunks = 0 1 2 3